// Attachments
export const OVERRIDE_COMMENT_ATTACHMENTS = 'OVERRIDE_COMMENT_ATTACHMENTS';
export const OPEN_ADD_COMMENT_ATTACHMENTS = 'OPEN_ADD_COMMENT_ATTACHMENTS';

// Loading
export const LOADING_STATUS = 'LOADING_STATUS';
export const APP_DATA_LOADED = 'APP_DATA_LOADED';

// Auth
export const API_AUTHORIZED = 'API_AUTHORIZED';
export const API_UNAUTHORIZED = 'API_UNAUTHORIZED';
export const PERFORM_AUTH = 'PERFORM_AUTH';
export const PARSE_AUTH = 'PARSE_AUTH';
export const REDIRECT_LOGIN = 'REDIRECT_LOGIN';
export const AUTH_OK = 'AUTH_OK';
export const USER_LOGGEDIN = 'USER_LOGGEDIN';
export const USER_LOGOUT = 'USER_LOGOUT';

// API
export const API_CLEAR = 'API_CLEAR';
export const API_UPLOADED = 'API_UPLOADED';
export const API_LOADED_PREFIX = 'API_LOADED_';
export const API_LOADED_LOCATIONS = `${API_LOADED_PREFIX}LOCATIONS`;
export const API_LOADED_AFFILIATES = `${API_LOADED_PREFIX}AFFILIATES`;
export const API_LOADED_STAFFLIST = `${API_LOADED_PREFIX}STAFFLIST`;
export const API_LOADED_SERVICE_CONFIGS = `${API_LOADED_PREFIX}SERVICE_CONFIGS`;

// Data
export const RESET_AFFILIATE = 'RESET_AFFILIATE';
export const AFFILIATE_PRESELECTED = 'AFFILIATE_PRESELECTED';
export const AFFILIATE_PRESELECTED_INCORRECT = 'AFFILIATE_PRESELECTED_INCORRECT';
export const LOAD_SELECTED_AFFILIATE = 'LOAD_SELECTED_AFFILIATE';
export const GET_REQUEST_BY_ID = 'GET_REQUEST_BY_ID';
export const GET_WORKORDER_BY_ID = 'GET_WORKORDER_BY_ID';

// Filters
export const CLEAR_FILTER = 'CLEAR_FILTER';
export const SET_FILTER = 'SET_FILTER';
export const FILTER_REQUESTS = 'FILTER_REQUESTS';
export const FILTER_WORKORDERS = 'FILTER_WORKORDERS';

// Clear Data
export const CLEAR_LOCATIONS = 'CLEAR_LOCATIONS';

// Notification
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';
export const REDIRECT_NOTIFICATION = 'REDIRECT_NOTIFICATION';
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';
export const CUSTOM_ACTION_NOTIFICATION = 'CUSTOM_ACTION_NOTIFICATION';

// PullToRefresh
export const START_REFRESHING = 'START_REFRESHING';
export const END_REFRESHING = 'END_REFRESHING';
export const ADD_REFRESHING_FUNC = 'ADD_REFRESHING_FUNC';
export const CALL_REFRESHING_FUNC = 'CALL_REFRESHING_FUNC';
export const REMOVE_REFRESHING_FUNC = 'REMOVE_REFRESHING_FUNC';

export const REFRESH_NEW_SR = 'REFRESH_NEW_SR';

// Defaults
export const REDUX_INIT = '@@redux/INIT';
export const ROUTE_CHANGE = '@@router/LOCATION_CHANGE';

// Service Requests
export const SERVICE_REQUEST_STATUS_UPDATE = 'SERVICE_REQUEST_STATUS_UPDATE';
export const REQUEST_ADD_COMMENT = 'REQUEST_ADD_COMMENT';
export const SERVICE_REQUEST_ASSIGNED = 'SERVICE_REQUEST_ASSIGNED';
export const VIEWS_REQUESTS_SET_SORT = 'VIEWS/REQUESTS/SET_SORT';
export const VIEWS_REQUESTS_SET_FILTER = 'VIEWS/REQUESTS/SET_FILTER';

// Work Orders
export const WORK_ORDER_CREATED = 'WORK_ORDER_CREATED';
export const WORK_ORDER_STATUS_UPDATE = 'WORK_ORDER_STATUS_UPDATE';
export const WORK_ORDER_ADD_COMMENT = 'WORK_ORDER_ADD_COMMENT';
export const WORK_ORDER_ADD_ATTACHMENT = 'WORK_ORDER_ADD_ATTACHMENT';

// App Info
export const SET_APP_INFO = 'SET_APP_INFO';
export const APP_TOGGLE_AVAILABLE = 'APP_TOGGLE_AVAILABLE';

// Header
export const SET_HEADER_TITLE = 'SET_HEADER_TITLE';

// HELP
export const SET_HELP_PAGE = 'SET_HELP_PAGE';

// LOCALE
export const LOCALE_FETCH_FAILED = 'LOCALE_FETCH_FAILED';

// Rooms
export const LOCATION_UPDATE = 'LOCATION_UPDATE';



// WEBPACK FOOTER //
// ./src/state/types.js